module.exports = __webpack_public_path__ + "static/media/feeder.4057ea32.png";